import { Dispatch, SetStateAction } from 'react';
import {
  Modal,
  TextField,
  Button,
  MenuItem,
  Select,
  SelectChangeEvent
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useAddSettingsMutation } from '../services/settings';
import { showError, showToast } from '../constants/toasts';

interface Props {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  onSuccess?: () => void;
}

export default function AddAgeGroup({ open, onClose, setOpen, onSuccess }: Props) {

  const [Category, setCategory] = React.useState('default');
  const handleCategoryChange = (event: SelectChangeEvent) => {
    setCategory(event.target.value as string);
  };

  const [addSettings, { isLoading }] = useAddSettingsMutation();

  const formik = useFormik({
    initialValues: {
      start_range: '',
      end_range: '',
    },
    validationSchema: Yup.object({
      start_range: Yup.string().required('Start range is required'),
      end_range: Yup.string().required('End range is required'),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        const res: any = await addSettings({ body: values }).unwrap();
        if (res?.status === 201) {
          showToast('Age group created successfully.');
          resetForm();
          setOpen(false);
          onSuccess && onSuccess();
        } else {
          showError(res?.message || 'Failed to add age group');
        }
      } catch (e: any) {
        showError(e?.data?.message || 'Failed to add age group');
      }
    },
  });

  return (
    <Modal
      className="modal alertConfig_modal"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Age Group </h2>
            <div className="btn-close" onClick={() => setOpen(false)}>
              <CloseIcon />
            </div>
          </div>

          <form className="form" onSubmit={formik.handleSubmit}>
            <div className="control_group">
              <label>Age Range Start</label>
              <TextField
                fullWidth
                hiddenLabel
                placeholder="Enter Age"
                name="start_range"
                value={formik.values.start_range}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.start_range && Boolean(formik.errors.start_range)}
                helperText={formik.touched.start_range && formik.errors.start_range}
              />
            </div>
            <div className="control_group">
              <label>Age Range End</label>
              <TextField
                fullWidth
                hiddenLabel
                placeholder="Enter Age"
                name="end_range"
                value={formik.values.end_range}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.end_range && Boolean(formik.errors.end_range)}
                helperText={formik.touched.end_range && formik.errors.end_range}
              />
            </div>
            <div className="footer_btn_flex">
              <Button className="btn btn_grey" onClick={() => setOpen(false)} disabled={isLoading}>Cancel</Button>
              <Button className="btn btn_primary" type="submit" disabled={isLoading}>Submit</Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
